import Modal from "react-modal";
import css from "./GlobalModal.module.scss";
import Button from "../atoms/Button";
import { motion } from "framer-motion";

export default function GlobalModal({
    children,
    buttons,
    modalState,
    title,
    closeFunction,
    doScroll = false,
}) {
    // modal state should be received from parent element!

    // if (typeof document !== "undefined") {
    //    Modal.setAppElement(document.getElementById("__next")); // for accessiblity
    // }

    Modal.setAppElement("body");

    function handleCloseModal() {
        modalState && modalState.setShowModal(false);
        closeFunction && closeFunction();
    }

    return (
        <Modal
            isOpen={true}
            shouldCloseOnOverlayClick={true}
            onRequestClose={handleCloseModal}
            className={css["modal"]}
            overlayClassName={css["overlay"]}
        >
            <motion.div className={css["structure"]}>
                <header className={css["header"]}>
                    <h3>{title}</h3>
                    <Button
                        iconLeft="fa fa-times"
                        size="s"
                        action={handleCloseModal}
                        variant="secondary"
                        color="gray"
                        style={{
                            width: "24px",
                            height: "24px",
                        }}
                    />
                </header>
                <div className={css["content"]}>{children}</div>
                {buttons && <div className={css["buttons"]}>{buttons}</div>}
            </motion.div>
        </Modal>
    );
}
